module.exports = __webpack_public_path__ + "img/wide.9538fc60.jpg";